// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { PracticeAddress } from './practice-address';
import { PracticeBank } from './practice-bank';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Practice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  practiceId!: number;
  corroName?: string;
  createdBy!: string;
  createdDate!: Date;
  managedDocumentsPath?: string;
  practiceName?: string;
  regAgentNo?: string;
  subLocationId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  admins!: Admin[];
  practiceAddresses!: PracticeAddress[];
  practiceBanks!: PracticeBank[];
  userPractices!: User[];
  userReportingPractices!: User[];
}

